import { render } from "./MiraIcon.vue?vue&type=template&id=6cfaa76e&scoped=true"
import script from "./MiraIcon.vue?vue&type=script&lang=js"
export * from "./MiraIcon.vue?vue&type=script&lang=js"

import "./MiraIcon.vue?vue&type=style&index=0&id=6cfaa76e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cfaa76e"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
